/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Warning_Wpm_TitleInputs */

const en_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM warning: WPM (${i?.wpm}) is above max value`)
};

const fr_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alerte MPM : le MPM (${i?.wpm}) dépasse la valeur maximale`)
};

const de_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM-Warnung: WPM (${i?.wpm}) liegt über dem Maximalwert`)
};

const it_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avviso WPM: WPM (${i?.wpm}) è superiore al valore massimo`)
};

const ru_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предупреждение: скорость печати (${i?.wpm}) превышает максимальное значение.`)
};

const es_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Advertencia de WPM: WPM (${i?.wpm}) está por encima del valor máximo`)
};

const zh_cn2_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM 警告：WPM (${i?.wpm}) 超过最大值`)
};

const ja_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM警告: WPM (${i?.wpm}) が最大値を超えています`)
};

const hi_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`WPM चेतावनी: WPM (${i?.wpm}) अधिकतम मान से अधिक है`)
};

const pt_pt2_event_warning_wpm_title = /** @type {(inputs: Event_Warning_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aviso de WPM: WPM (${i?.wpm}) está acima do valor máximo.`)
};

/**
* | output |
* | --- |
* | "WPM warning: WPM ({wpm}) is above max value" |
*
* @param {Event_Warning_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_wpm_title = /** @type {((inputs: Event_Warning_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_wpm_title(inputs)
	if (locale === "de") return de_event_warning_wpm_title(inputs)
	if (locale === "it") return it_event_warning_wpm_title(inputs)
	if (locale === "ru") return ru_event_warning_wpm_title(inputs)
	if (locale === "es") return es_event_warning_wpm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_wpm_title(inputs)
	if (locale === "ja") return ja_event_warning_wpm_title(inputs)
	if (locale === "hi") return hi_event_warning_wpm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_wpm_title(inputs)
	return en_event_warning_wpm_title(inputs)
});